import Img from "./components/Img";
import SendEmail from "./components/SendEmail";
import GoogleMap from "./components/GoogleMap";
import Main from "./components/Main";
import ReactGA from 'react-ga4';
import { useEffect } from "react";
ReactGA.initialize('GTM-M7XP2QM');

function App() {

  const imgUrl = [
    'images/2.jpg',
    'images/3.jpg',
    'images/4.jpg',
    'images/5.jpg'
  ]

  useEffect(() => {
    ReactGA.send("pageview")
  },[])

  return (
    <div className="App">
      <Main image='images/1.jpg'/>
      {
        imgUrl.map((url,i) => <Img key={i} image={url}/>)
      }
      <GoogleMap /> 
      <SendEmail />

    </div>
  );
}

export default App;
